import { render, staticRenderFns } from "./CabinetMenuItem.vue?vue&type=template&id=71108b5a&scoped=true&"
import script from "./CabinetMenuItem.vue?vue&type=script&lang=js&"
export * from "./CabinetMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./CabinetMenuItem.vue?vue&type=style&index=0&id=71108b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71108b5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71108b5a')) {
      api.createRecord('71108b5a', component.options)
    } else {
      api.reload('71108b5a', component.options)
    }
    module.hot.accept("./CabinetMenuItem.vue?vue&type=template&id=71108b5a&scoped=true&", function () {
      api.rerender('71108b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/CabinetMenuItem.vue"
export default component.exports